export enum DepositStep {
  BUNDLES = 'bundles',
  DAILY_BUNDLE_INFO = 'daily-bundle-info',
  VIP_BUNDLE_INFO = 'vip-bundle-info',
}
